import request from './axios';

/**
 * 获取企业文化列表
 * @returns {Promise<Object>} 返回企业文化列表
 */
export function getCultureList() {
  return request({
    url: '/webapi/culture/list',
    method: 'get'
  });
}

/**
 * 获取企业文化详情
 * @param {String} id 企业文化ID
 * @returns {Promise<Object>} 返回企业文化详情
 */
export function getCultureDetail(id) {
  return request({
    url: `/webapi/culture/detail/${id}`,
    method: 'get'
  });
} 